import styled from "styled-components";
import { colors, values } from "~/assets/js/theme/constants";

const getIconColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.WHITE;
        case "default":
            return colors.WHITE;
        case "remove":
            return colors.SEMANTIC.DANGER[1000];
        case "subtle":
            return colors.LAYOUT.GRAY[600];
    }
};

const getBackgroundColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.GRADIENT.LEFT;
        case "default":
            return colors.LAYOUT.GRAY[1000];
        case "remove":
            return colors.SEMANTIC.DANGER[100];
        case "subtle":
            return colors.LAYOUT.GRAY[300];
    }
};

const getBackgroundHoverColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.GRADIENT.LEFT;
        case "default":
            return colors.LAYOUT.GRAY[900];
        case "remove":
            return colors.SEMANTIC.DANGER[100];
        case "subtle":
            return colors.LAYOUT.GRAY[400];
    }
};

export const StyledButton = styled.div`
    height: ${(props) =>
        props.rounded ? props.size || 34 : props.size || 30}px;
    width: ${(props) =>
        props.rounded ? props.size || 34 : props.size || 30}px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: ${(props) => (props.rounded ? 500 : values.BORDER_RADIUS)}px;
    background: ${(props) => getBackgroundColor(props)};
    transition: ${values.DEFAULT_TRANSITION_DURATION};

    &:hover,
    &:active,
    &:focus {
        background: ${(props) => getBackgroundHoverColor(props)};
        ${(props) => (props.disabled ? "" : `filter: brightness(110%);`)}
    }
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
    ${(props) => (props.disabled ? "filter: grayscale(100%);" : "")}
`;

export const LoadingContainer = styled.div`
    margin-right: 16px;
    filter: brightness(1000%);
`;

export const Mask = styled.div`
    height: ${(props) => props.iconSize}px;
    width: ${(props) => props.iconSize}px;
    -webkit-mask: url(${(props) => props.icon}) no-repeat center;
    mask: url(${(props) => props.icon}) no-repeat center;
    background-color: ${(props) => getIconColor(props)};
    mask-size: 100%;
    -webkit-mask-size: 100%;
    transition: ${values.DEFAULT_TRANSITION_DURATION};
`;
